module.exports = __webpack_public_path__ + "static/media/image-11.8cd88016.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeDo/image-11.jpg
// module id = 73
// module chunks = 0